import * as React from 'react';
import styled from 'styled-components';
import { LIST_VARIANT, MARGIN, COLOR } from '@latitude/core/utils/constants';
var StyledList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "List__StyledList",
  componentId: "sc-1qtiztv-0"
})(["margin:0 0 0 ", ";padding:0;list-style-position:outside;li{position:relative;list-style:none;margin:0 0 ", " 0;::before{font-size:36px;position:absolute;top:0;left:-", ";content:'\u2022';color:", ";}}"], function (_ref) {
  var marginLeft = _ref.marginLeft;
  return marginLeft;
}, function (_ref2) {
  var itemMarginBottom = _ref2.itemMarginBottom;
  return itemMarginBottom;
}, MARGIN.M24, function (_ref3) {
  var dotColor = _ref3.dotColor;
  return dotColor;
});

var List = function List(_ref4) {
  var id = _ref4.id,
      className = _ref4.className,
      children = _ref4.children,
      _ref4$dotColor = _ref4.dotColor,
      dotColor = _ref4$dotColor === void 0 ? COLOR.BLUE_LIGHT : _ref4$dotColor,
      _ref4$itemMarginBotto = _ref4.itemMarginBottom,
      itemMarginBottom = _ref4$itemMarginBotto === void 0 ? MARGIN.M0 : _ref4$itemMarginBotto,
      _ref4$marginLeft = _ref4.marginLeft,
      marginLeft = _ref4$marginLeft === void 0 ? MARGIN.M24 : _ref4$marginLeft,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? LIST_VARIANT.UL : _ref4$variant;
  var props = {
    id: id,
    className: className,
    dotColor: dotColor,
    itemMarginBottom: itemMarginBottom,
    marginLeft: marginLeft
  };
  return /*#__PURE__*/React.createElement(StyledList, Object.assign({
    as: variant
  }, props), children);
};

export default List;